/**
 * ai 接口
 */
import axios from '@/util/request'

const baseURL = process.env.VUE_APP_API_URL

export default {
  getCustomModels: data => axios({ baseURL, url: '/api/product/open/custom/pod/getCustomModels', method: 'POST', data }), // 获取版型列表(前台)
  getUserCustomImages: params => axios({ baseURL, url: '/api/product/custom/pod/userCustomImages', method: 'GET', params }), // 获取用户定制图片(前台)
  addUserCustomImages: data => axios({ baseURL, url: '/api/product/custom/pod/userCustomImages', method: 'POST', data }), // 定制用户图片保存(前台)
  delUserCustomImages: data => axios({ baseURL, url: '/api/product/custom/pod/customImage', method: 'DELETE', data }), // 删除用户图素材图片(前台)
  saveDesignedProduct: data => axios({ baseURL, url: '/api/product/custom/pod/designedProduct', method: 'POST', data }), // 保存设计产品信息(前台)

  // 用户设计列表
  getDesignedProducts: data => axios({ baseURL, url: '/api/product/custom/pod/getDesignedProducts', method: 'POST', data }), // 获取已设计产品列表(前台)
  delDesignedProduct: data => axios({ baseURL, url: '/api/product/custom/pod/designedProduct', method: 'DELETE', data }) // 删除已设计产品信息(前台)

}
